"use strict";
import Api from "../../api/api";
export class LoadShipment {
  constructor(loadShipment) {
    this.loadShipment = loadShipment;
  }
  isApproved() {
    return this.loadShipment.state === "Approved";
  }
  unapprovingAllowed() {
    const settings = Api.Account.currentSettings() || {};
    const blockedStatuses = settings["shipment_block_unapprove_statuses_for_billing"] || [];
    return !blockedStatuses.includes(this.loadShipment.shipment_status);
  }
}
